import Vue from 'vue';
import VoucherBySerialIdQuery from '@/plugins/graphql/queries/v2/store_add_ons/voucher-by-serial-id.gql';
import { VoucherRebateModel } from '@/helpers/entities/models/VoucherRebateModel';
export default Vue.extend({
    apollo: {
        voucherBySerialId: {
            query: VoucherBySerialIdQuery,
            variables() {
                return {
                    serialId: this.serialId,
                };
            },
            update(data) {
                return new VoucherRebateModel(data.voucherBySerialId);
            },
        },
    },
    props: {
        serialId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            voucherBySerialId: {},
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            let additionalVoucherExist = false;
            if (Object.keys(this.voucherBySerialId).length > 0) {
                additionalVoucherExist = true;
            }
            return this.$scopedSlots.default({
                addVoucherBySerialId: this.voucherBySerialId,
                additionalVoucherExist,
            });
        }
    },
});
